var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"line-chart"},[(_vm.loading)?_c('v-skeleton',{attrs:{"width":"100%","height":"100%"}}):_c('LineChart',{attrs:{"chart-id":_vm.chartId,"chart-data":_vm.chartData,"chart-options":_vm.chartOptions,"styles":_vm.wrapperStyles}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }